import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import { Box } from '@mui/material';
import type { ReactElement } from 'react';

// Tailwind only sees literal class names, so each tile size is spelled out rather than computed.
const TILE_CLASSES = {
  sm: 'vtwo:h-10 vtwo:w-10',
  lg: 'vtwo:h-16 vtwo:w-16',
} as const;

const IMAGE_CLASSES = {
  sm: 'vtwo:h-6 vtwo:w-6',
  lg: 'vtwo:h-10 vtwo:w-10',
} as const;

const PLACEHOLDER_CLASSES = {
  sm: 'vtwo:text-[20px]',
  lg: 'vtwo:text-[32px]',
} as const;

interface SectionTypeIconProps {
  iconUrl?: string | null;
  /** `sm` (40px) for the section type sidebar, `lg` (64px) for the page structure rows. */
  size?: keyof typeof TILE_CLASSES;
}

// Decorative only: the section name always sits next to the tile, so the icon is kept out of the
// accessibility tree instead of repeating that name.
export function SectionTypeIcon({ iconUrl, size = 'sm' }: SectionTypeIconProps): ReactElement {
  return (
    <Box
      className={`vtwo:flex ${TILE_CLASSES[size]} vtwo:shrink-0 vtwo:items-center vtwo:justify-center vtwo:overflow-hidden vtwo:rounded-lg vtwo:border vtwo:border-plus-border vtwo:bg-plus-muted`}
    >
      {iconUrl ? (
        <img
          src={iconUrl}
          alt=""
          aria-hidden="true"
          className={`${IMAGE_CLASSES[size]} vtwo:object-contain`}
        />
      ) : (
        <WidgetsOutlinedIcon className={`${PLACEHOLDER_CLASSES[size]} vtwo:text-gray-500`} />
      )}
    </Box>
  );
}
